import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import { css, styled } from 'styled-components'

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${phone(css`
    gap: 16px;
  `)};
`
